import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import EcommIMg from "../../images/Ecommerce.jpg";

const RetailEcommerceHero = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100vh",
        backgroundImage: `url(${EcommIMg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Soft overlay for readability */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: "rgba(0,0,0,0.15)",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            bgcolor: "rgba(22, 45, 180, 0.82)",
            px: { xs: 3, md: 6 },
            py: { xs: 4, md: 6 },
            width: "100%",
            maxWidth: 1180,
            mx: "auto",
          }}
        >
          <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
            {/* Left: Title */}
            <Grid item xs={12} md={5}>
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                  fontSize: { xs: 35, sm: 45, md: 58 },
                  lineHeight: { xs: 1.05, md: 1.0 },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Retail and
                <br />
                Consumer
                <br />
                Solutions
              </Typography>
            </Grid>

            {/* Divider */}
            <Grid
              item
              xs={12}
              md={1}
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: "2px",
                  height: 190,
                  bgcolor: "rgba(255,255,255,0.7)",
                }}
              />
            </Grid>

            {/* Right: Description */}
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.95)",
                  fontSize: { xs: 14, md: 16 },

                  lineHeight: 1.8,
                  fontWeight: 600,
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Consumer-sentiment is the main driver for the Retail and
                Consumer Packaged Goods Industry. As consumption patterns change
                and the developing world takes a bigger share of the pie in the
                global market, the industry is searching for opportunities for
                growth by reaching out to new markets and innovating to meet
                local demands. How can AlphaForce help the retail industry?
                First, to be competitive in the market and protect your margins,
                you need usable data. AlphaForce can provide beginning to end
                data analytics and reporting solutions designed to take relevant
                publicly available data and proprietary data to provide decision
                makers with the information they need to make smart decisions.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

const RetailEcommerce = () => {
  return (
    <Box>
      <RetailEcommerceHero />
      {/* Additional Retail & Ecommerce sections go here */}
    </Box>
  );
};

export default RetailEcommerce;
